// extracted by css-extract-rspack-plugin
export default {"groupLabel":"groupLabel-ZhVE2G"};